import { makeConstantFactory } from 'utils/constantsHelper'
const makeConstant = makeConstantFactory('integrations')

export const FETCH_INTEGRATION_STATES = makeConstant('FETCH_INTEGRATION_STATES')
export const FETCH_INTEGRATION_STATES_SUCCESS = makeConstant('FETCH_INTEGRATION_STATES_SUCCESS')
export const FETCH_INTEGRATION_STATES_FAILED = makeConstant('FETCH_INTEGRATION_STATES_FAILED')
export const FETCH_INTEGRATION_STATES_PENDING = makeConstant('FETCH_INTEGRATION_STATES_PENDING')

export const UPDATE_INTEGRATION_STATE = makeConstant('UPDATE_INTEGRATION_STATE')
export const UPDATE_INTEGRATION_STATE_SUCCESS = makeConstant('UPDATE_INTEGRATION_STATE_SUCCESS')
export const UPDATE_INTEGRATION_STATE_FAILED = makeConstant('UPDATE_INTEGRATION_STATE_FAILED')
export const UPDATE_INTEGRATION_STATE_PENDING = makeConstant('UPDATE_INTEGRATION_STATE_PENDING')

export const FETCH_PAGINATED_INTEGRATION_EVENTS = makeConstant('FETCH_PAGINATED_INTEGRATION_EVENTS')
export const FETCH_PAGINATED_INTEGRATION_EVENTS_SUCCESS = makeConstant('FETCH_PAGINATED_INTEGRATION_EVENTS_SUCCESS')

export const POST_BUSINESS_EVENT_CSV = makeConstant('POST_BUSINESS_EVENT_CSV')
export const POST_BUSINESS_EVENT_CSV_SUCCESS = makeConstant('POST_BUSINESS_EVENT_CSV_SUCCESS')
export const POST_BUSINESS_EVENT_CSV_FAILED = makeConstant('POST_BUSINESS_EVENT_CSV_FAILED')

export const FETCH_INTEGRATION_EVENTS = makeConstant('FETCH_INTEGRATION_EVENTS')
export const FETCH_INTEGRATION_EVENTS_SUCCESS = makeConstant('FETCH_INTEGRATION_EVENTS_SUCCESS')
export const FETCH_INTEGRATION_EVENTS_FAILED = makeConstant('FETCH_INTEGRATION_EVENTS_FAILED')
export const FETCH_INTEGRATION_EVENTS_PENDING = makeConstant('FETCH_INTEGRATION_EVENTS_PENDING')

export const DESTORY_INTEGRATION_EVENTS = makeConstant('DESTORY_INTEGRATION_EVENTS')

export const FETCH_FACEBOOK_SETTINGS = makeConstant('FETCH_FACEBOOK_SETTINGS')
export const FETCH_FACEBOOK_SETTINGS_PENDING = makeConstant('FETCH_FACEBOOK_SETTINGS_PENDING')
export const FETCH_FACEBOOK_SETTINGS_FAILED = makeConstant('FETCH_FACEBOOK_SETTINGS_FAILED')
export const FETCH_FACEBOOK_SETTINGS_SUCCESS = makeConstant('FETCH_FACEBOOK_SETTINGS_SUCCESS')
export const FETCH_FACEBOOK_SETTINGS_CANCELLED = makeConstant('FETCH_FACEBOOK_SETTINGS_CANCELLED')

export const FETCH_OUTREACH_STATUS = makeConstant('FETCH_OUTREACH_STATUS')
export const FETCH_OUTREACH_STATUS_PENDING = makeConstant('FETCH_OUTREACH_STATUS_PENDING')
export const FETCH_OUTREACH_STATUS_FAILED = makeConstant('FETCH_OUTREACH_STATUS_FAILED')
export const FETCH_OUTREACH_STATUS_SUCCESS = makeConstant('FETCH_OUTREACH_STATUS_SUCCESS')

export const CREATE_ACCESS_TOKEN = makeConstant('CREATE_ACCESS_TOKEN')
export const CREATE_ACCESS_TOKEN_PENDING = makeConstant('CREATE_ACCESS_TOKEN_PENDING')
export const CREATE_ACCESS_TOKEN_FAILED = makeConstant('CREATE_ACCESS_TOKEN_FAILED')
export const CREATE_ACCESS_TOKEN_SUCCESS = makeConstant('CREATE_ACCESS_TOKEN_SUCCESS')

export const CREATE_SLACKBOT_TOKEN = makeConstant('CREATE_SLACKBOT_TOKEN')

export const SET_WORDPRESS_V2_INTEGRATION = makeConstant('SET_WORDPRESS_V2_INTEGRATION')
export const SET_WORDPRESS_V2_INTEGRATION_PENDING = makeConstant('SET_WORDPRESS_V2_INTEGRATION_PENDING')
export const SET_WORDPRESS_V2_INTEGRATION_SUCCESS = makeConstant('SET_WORDPRESS_V2_INTEGRATION_SUCCESS')
export const SET_WORDPRESS_V2_INTEGRATION_FAILED = makeConstant('SET_WORDPRESS_V2_INTEGRATION_FAILED')

export const SET_WORDPRESS_DOMAIN = makeConstant('SET_WORDPRESS_DOMAIN')
export const SET_WORDPRESS_DOMAIN_PENDING = makeConstant('SET_WORDPRESS_DOMAIN_PENDING')
export const SET_WORDPRESS_DOMAIN_SUCCESS = makeConstant('SET_WORDPRESS_DOMAIN_SUCCESS')
export const SET_WORDPRESS_DOMAIN_FAILED = makeConstant('SET_WORDPRESS_DOMAIN_FAILED')

export const FETCH_WORDPRESS_DOMAIN = makeConstant('FETCH_WORDPRESS_DOMAIN')
export const FETCH_WORDPRESS_DOMAIN_PENDING = makeConstant('FETCH_WORDPRESS_DOMAIN_PENDING')
export const FETCH_WORDPRESS_DOMAIN_SUCCESS = makeConstant('FETCH_WORDPRESS_DOMAIN_SUCCESS')
export const FETCH_WORDPRESS_DOMAIN_FAILED = makeConstant('FETCH_WORDPRESS_DOMAIN_FAILED')

export const FETCH_STRIPE_KEYS = makeConstant('FETCH_STRIPE_KEYS')
export const FETCH_STRIPE_KEYS_PENDING = makeConstant('FETCH_STRIPE_KEYS_PENDING')
export const FETCH_STRIPE_KEYS_FAILED = makeConstant('FETCH_STRIPE_KEYS_FAILED')
export const FETCH_STRIPE_KEYS_SUCCESS = makeConstant('FETCH_STRIPE_KEYS_SUCCESS')
export const FETCH_STRIPE_KEYS_CANCELLED = makeConstant('FETCH_STRIPE_KEYS_CANCELLED')

export const CREATE_SANDBOX_ACCESS_TOKEN = makeConstant('CREATE_SANDBOX_ACCESS_TOKEN')

export const GET_LEANDATA_AUTH_STATUS = makeConstant('GET_LEANDATA_AUTH_STATUS')
export const GET_LEANDATA_AUTH_STATUS_PENDING = makeConstant('GET_LEANDATA_AUTH_STATUS_PENDING')
export const GET_LEANDATA_AUTH_STATUS_FAILED = makeConstant('GET_LEANDATA_AUTH_STATUS_FAILED')
export const GET_LEANDATA_AUTH_STATUS_CANCELLED = makeConstant('GET_LEANDATA_AUTH_STATUS_CANCELLED')
export const GET_LEANDATA_AUTH_STATUS_SUCCESS = makeConstant('GET_LEANDATA_AUTH_STATUS_SUCCESS')

export const GoogleScopes = Object.freeze({
  CALENDAR: 'https://www.googleapis.com/auth/calendar',
  READ: 'https://www.googleapis.com/auth/gmail.readonly',
  SEND: 'https://www.googleapis.com/auth/gmail.send',
})

export const LeanDataAuthStatuses = Object.freeze({
  UNSUCCESSFUL_API_REQUEST: "UNSUCCESSFUL_API_REQUEST",
  SALESFORCE_AUTHENTICATION_ISSUE: "SALESFORCE_AUTHENTICATION_ISSUE",
  LEANDATA_USER_PERMISSIONS:  "LEANDATA_USER_PERMISSIONS",
  LEANDATA_ORGANIZATION_PERMISSIONS:  "LEANDATA_ORGANIZATION_PERMISSIONS",
  NO_ERROR: "NO_ERROR"
})



// WEBPACK FOOTER //
// ./src/scripts/app/modules/integrations/constants.js